import $ from 'jquery';
import { Chart } from 'chart.js';

function pieLegendCallbackSingle(chartLegend) {
    var text = [];
    text.push('<div class="0-legend chart-legend">');
    for (var i = 0; i < chartLegend.length; i++) {
        if (chartLegend.length > 0) {
            text.push(
                '<div class="chart-legend__row"><div class="chart-legend__company"><div class="chart-legend__indicator" style="background-color:' +
                chartLegend[i][2] +
                '"></div>'
            );
            text.push(chartLegend[i][0]);
            text.push(
                '</div><div class="chart-legend__value">' +
                chartLegend[i][1] +
                "</div></div>"
            );
        }
    }
    text.push("</div>");
    return text.join("");
}

function generatePieLegendSingle(chartLegend) {
    var pieLegend = document.querySelector("[data-pie-legend-single]");
    if (pieLegend && chartLegend) pieLegend.innerHTML = pieLegendCallbackSingle(chartLegend);
}

$(document).on("turbo:load", function() {
    var pieChart = $("[data-investments-pie-chart-single]");
    if (!pieChart.length) return;
    var canvas = pieChart[0];
    var chartData = pieChart.data("chartData");
    var chartLegend = pieChart.data("chartLegend");
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) return;
    var chartLabels = [];
    var chartValues = [];
    var chartColours = [];
    for (var i = 0; i < chartData.length; i++) {
        chartLabels.push(chartData[i][0]);
        chartValues.push(chartData[i][1]);
        chartColours.push(chartData[i][2]);
    }
    var chart = new Chart(canvas, {
            type: "pie",
            data: {
                datasets: [
                    {
                        data: chartValues,
                        backgroundColor: chartColours,
                        borderWidth: 0,
                    },
                ],
                labels: chartLabels,
            },
            options: {
                legend: {
                    display: false,
                },
                tooltips: {
                    backgroundColor: "#FFF",
                    cornerRadius: 0,
                    titleFontFamily: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
                    bodyFontFamily: "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif",
                    titleFontSize: 14,
                    bodyFontSize: 14,
                    titleMarginBottom: 8,
                    xPadding: 10,
                    yPadding: 14,
                    displayColors: false,
                    borderWidth: 1,
                    borderColor: "#d9e0e0",
                    titleFontColor: "black",
                    bodyFontColor: "black",
                    caretSize: 8,
                    caretPadding: 8,
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var label = data.labels[tooltipItem.index] || "";

                            if (label) {
                                label += ": ";
                            }
                            label +=
                                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €";
                            return label;
                        },
                    },
                },
            },
        });
    generatePieLegendSingle(chartLegend);
});
